<div class="details">
  <div class="order-details-products">
    <div class="products-header">
      <span class="items-count">
        <!-- @if (itemsCount) { ({{ itemsCount }})
        {{ itemsCount === 1 ? "Item" : "Items" }}
        } -->
        @if (order.bundleId) {
          {{ order.bundleName }}
        } @else {
          My Bundle
        }
      </span>

      <a
        href="javascript:void(0);"
        [ngClass]="{ disabled: isProcessing }"
        (click)="isProcessing ? null : openDialogUpdateBundle()"
      >
        Change Bundle
      </a>
    </div>

    @for (item of displayItems; track item.id) {
      <lib-scheduled-order-bundle-details-product
        [orderItem]="item"
        [orderVerboseName]="orderVerboseName"
        [orderStatus]="order.status"
        [siteSettings]="siteSettings"
        (itemPrice)="onItemPrice($event)"
      />
    }
    @if (
      isFreeShipping || (totalSavingsPercentage && totalSavingsPercentage > 0)
    ) {
      <lib-bar-tag
        [className]="'autoship-save'"
        [icon]="'sell'"
        actionName="-{{
          totalSavings | number: '1.0-2' | currency: 'USD' : 'symbol'
        }}"
        [isActionClickable]="false"
        text="{{
          siteSettings.localization?.autoshipAndSave
            ? siteSettings.localization?.autoshipAndSave
            : 'Autoship & Save'
        }} {{ totalSavingsPercentage | number: '1.0-2' }}%"
      />
    }

    <div class="separator"></div>
    <div class="products-actions">
      <md-outlined-button
        [disabled]="isProcessing"
        (click)="isProcessing ? null : openDialogUpdateBundle()"
      >
        <span slot="icon" class="btn-icon material-symbols-outlined">add</span>
        <span class="button-text">
          @if (
            rewardDiscountPercentage &&
            frequencyDiscountPercentage &&
            itemCountToActivateReward
          ) {
            Save Up to
            {{ rewardDiscountPercentage + frequencyDiscountPercentage }}%
            {{
              isFreeShipping
                ? "and Get Free Shipping With " +
                  itemCountToActivateReward +
                  " Items"
                : ""
            }}
          }
        </span>
      </md-outlined-button>
    </div>
  </div>
</div>
